import { createSelector } from 'reselect';

const selectModalsState = (state) => state.modalsReducer;

export const getModalProps = () => createSelector(selectModalsState, (state) => state.modalData);

